import { notification } from 'antd';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { BackButton } from 'src/components/BackButton/BackButton';
import { EditFormPage } from 'src/components/FormPages/EditFormPage';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { UpdatePartnerRequest } from 'src/generated-api-client';
import { useLoadResources } from 'src/hooks/useLoadResources';
import { PartnerCreateForm } from 'src/pages/PartnersCreate/components/PartnerCreateForm';
import { PartnersStore } from 'src/stores/PartnersStore/PartnersStore';
import { CountryResourceStore } from 'src/stores/Resources/CountryResourceStore';
import { JahezComissionTypeResourceStore } from 'src/stores/Resources/JahezComissionTypeResourceStore';
import { PartnerTypeResourceStore } from 'src/stores/Resources/PartnerTypeResourceStore';
import { ProductOfferingTypeResourceStore } from 'src/stores/Resources/ProductOfferingTypeResourceStore';
import { SpecializationResourceStore } from 'src/stores/Resources/SpecializationResourceStore';

export const PartnerEditPage = observer(() => {
    const { t } = useTranslation();
    const {
        params: { id },
    } = useRouteMatch<{ id: string }>();
    const { isLoadingResources } = useLoadResources([
        CountryResourceStore,
        SpecializationResourceStore,
        ProductOfferingTypeResourceStore,
        PartnerTypeResourceStore,
        JahezComissionTypeResourceStore,
    ]);

    const detailsUrl = EntityLinks.partners.itemDetails?.(id);

    const handleFinish = async (values: UpdatePartnerRequest) => {
        const newItem = await store.update(id, values);

        if (!store.updateItemLoader.hasError && newItem) {
            notification.success({
                message: t('App.Msgs.UpdateSuccess'),
            });

            detailsUrl && Router.navigate(detailsUrl);
        }
    };

    return (
        <EditFormPage
            store={store}
            pageName="partner-edit"
            title={t('App.Pages.PartnerEdit.Title')}
            saveText={<Trans i18nKey="App.Pages.PartnerEdit.SaveChanges" />}
            handleFinish={handleFinish}
            isLoading={isLoadingResources}
            showOnlyLoading={isLoadingResources}
            onCancel={() => {
                detailsUrl && Router.navigate(detailsUrl);
            }}
            headerTopPanel={<BackButton to={detailsUrl} />}
        >
            <PartnerCreateForm />
        </EditFormPage>
    );
});

const store = PartnersStore;
